import ChangeProductServices from './ChangeProductServices';
import ChangeProductServicesMock from './ChangeProductServicesMock';

const isMockingService = process.env.VUE_APP_MOCKING_SERVICES === 'true' || process.env.VUE_APP_MOCKING_SERVICES === true;
export default isMockingService ? ChangeProductServicesMock : ChangeProductServices;
